// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3IWXY","header":"ReportDetails_header__2zm61","title":"ReportDetails_title__1mXgb","left":"ReportDetails_left__2D6ij"};